import authenticate from '@/middleware/authenticate'
import store from '@/store'

export default [
  {
    path: '/pay-basic-salaries',
    name: 'pay-basic-salary',
    meta: { middleware: authenticate },
    component: () => import('@/pages/hr/pay-basic-salary/index.vue')
  }
]
